import React from "react";
import { Users, BarChart3, TrendingUp, UserPlus } from "lucide-react";

interface UserTrackingTabsProps {
  activeTab: "stats" | "analytics" | "users" | "new-users";
  setActiveTab: (tab: "stats" | "analytics" | "users" | "new-users") => void;
}

const UserTrackingTabs: React.FC<UserTrackingTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const tabs = [
    {
      id: "stats" as const,
      name: "Statistics",
      icon: Users,
      description: "User tracking statistics and metrics",
    },
    {
      id: "analytics" as const,
      name: "Analytics",
      icon: TrendingUp,
      description: "User behavior analytics and trends",
    },
    {
      id: "users" as const,
      name: "User Details",
      icon: BarChart3,
      description: "Detailed user tracking information",
    },
    {
      id: "new-users" as const,
      name: "New Users",
      icon: UserPlus,
      description: "Recently registered users",
    },
  ];

  return (
    <div className="bg-white shadow rounded-lg mb-6">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8 px-6">
          {tabs.map((tab) => {
            const IconComponent = tab.icon;
            const isActive = activeTab === tab.id;

            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`${
                  isActive
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors`}
              >
                <IconComponent className="h-5 w-5" />
                {tab.name}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Description */}
      <div className="px-6 py-4 bg-gray-50">
        <p className="text-sm text-gray-600">
          {tabs.find((tab) => tab.id === activeTab)?.description}
        </p>
      </div>
    </div>
  );
};

export default UserTrackingTabs;
